module.exports = __webpack_public_path__ + "static/media/wow2.63c2b473.mp3";